import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import InputSelectSF from '../../../widgets/form/InputSelectSF'
import InputTextAreaSF from '../../../widgets/form/InputTextAreaSF'

const StatusUpdateModalUI = ({ context, successMsg, errorList, setErrorList,
  // modes
  updateMode, submitted,
  // event handlers
  onSubmit, onCancelClick,
  // fields
  status, onStatusChange, statusError, setStatusError, statusList,
  subStatus, onSubStatusChange, subStatusError, setSubStatusError, subStatusList,
  reason, onReasonChange, reasonError, setReasonError,
}) =>
  <ModalFormUI
    context={context}
    titleLabel='Update status'
    buttonLabel='Update'
    cancelLabel='Cancel'
    isOpen={updateMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >
    <InputSelectSF type='select' name='status' required={true} label='Status'
      value={status} onChange={onStatusChange} optionList={statusList}
      error={statusError} setError={setStatusError}
    />
    <InputSelectSF type='select' name='subStatus' required={true} label='Sub status'
      value={subStatus} onChange={onSubStatusChange} optionList={subStatusList}
      error={subStatusError} setError={setSubStatusError}
    />
    <InputTextAreaSF type='text' name='reason' label='Reason'
      value={reason} onChange={onReasonChange}
      error={reasonError} setError={setReasonError}
    />
  </ModalFormUI>

export default StatusUpdateModalUI
